var _Path, _Path2, _Path3, _Path4, _Path5, _Path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgLibraryBuilding = function SvgLibraryBuilding(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.391,
    height: 20.46
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 41",
    d: "M9.845 0 0 4.74v2.466h20.391V4.727Zm9.186 5.847H1.359V5.59l8.506-4.1 9.166 4.108Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 42",
    d: "M0 20.46h20.391v-4.418H0Zm1.359-3.059h17.672v1.7H1.359Z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 43",
    d: "M2.379 8.226h1.359v6.8H2.379Z"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 44",
    d: "M16.653 8.226h1.359v6.8h-1.359Z"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 45",
    d: "M7.137 8.226h1.362v6.8H7.137Z"
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 46",
    d: "M11.895 8.226h1.359v6.8h-1.359Z"
  })));
};
export default SvgLibraryBuilding;